import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { AuthProvider } from './contexts/auth';

import './styles/global.scss';
import AppRoutes from './AppRoutes';

function App() {
  useEffect(() => {
    Modal.setAppElement('#global-modal');
  }, []);

  return (
    <>
      <div id='global-modal' />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </>
  );
}

export default App;
